<template>
  <!-- AI機能 SpeedDial: 右下に常駐、左に展開 -->
  <div v-if="showFab" class="ai-fab-container">
    <v-speed-dial
      v-model="isOpen"
      location="left center"
      transition="slide-x-reverse-transition"
    >
      <template #activator="{ props: activatorProps }">
        <v-btn
          v-bind="activatorProps"
          v-track="'ai-fab-toggle'"
          class="ai-fab"
          size="x-large"
          icon
          elevation="8"
        >
          <MiniTooltip v-if="!isOpen" text="AI機能" :offset-x="0" :offset-y="18">
            <v-icon size="32">mdi-creation</v-icon>
          </MiniTooltip>
          <v-icon v-else size="32" class="rotate-icon">mdi-close</v-icon>
        </v-btn>
      </template>

      <!-- AI地図チャット -->
      <v-btn
        v-track="'ai-fab-map-chat'"
        class="ai-fab-item"
        icon
        size="large"
        @click.stop="openMapChat"
      >
        <MiniTooltip text="AI地図チャット" :offset-x="0" :offset-y="18">
          <v-icon>mdi-chat-processing</v-icon>
        </MiniTooltip>
      </v-btn>

      <!-- AI防災診断 -->
      <v-btn
        v-track="'ai-fab-disaster'"
        class="ai-fab-item disaster"
        icon
        size="large"
        @click.stop="openDisasterAnalysis"
      >
        <MiniTooltip text="AI防災診断" :offset-x="0" :offset-y="18">
          <v-icon>mdi-shield-alert</v-icon>
        </MiniTooltip>
      </v-btn>

      <!-- AI人口プロファイル -->
      <v-btn
        v-track="'ai-fab-population'"
        class="ai-fab-item population"
        icon
        size="large"
        @click.stop="openPopulationProfile"
      >
        <MiniTooltip text="AI人口プロファイル" :offset-x="0" :offset-y="18">
          <v-icon>mdi-account-group</v-icon>
        </MiniTooltip>
      </v-btn>

      <!-- AI物件調査レポート -->
      <v-btn
        v-track="'ai-fab-property-report'"
        class="ai-fab-item instant"
        icon
        size="large"
        @click.stop="openPropertyReport"
      >
        <MiniTooltip text="AI物件調査レポート" :offset-x="0" :offset-y="18">
          <v-icon>mdi-home-search</v-icon>
        </MiniTooltip>
      </v-btn>

      <!-- AI物件調査レポート+ (複数地点比較) -->
      <v-btn
        v-track="'ai-fab-property-report-plus'"
        class="ai-fab-item property-plus"
        icon
        size="large"
        @click.stop="openMultiPointRanking"
      >
        <MiniTooltip text="AI物件調査レポート+" :offset-x="0" :offset-y="18">
          <v-icon>mdi-home-plus</v-icon>
        </MiniTooltip>
      </v-btn>

      <!-- AI子育てレポート -->
      <v-btn
        v-track="'ai-fab-childcare-report'"
        class="ai-fab-item childcare"
        icon
        size="large"
        @click.stop="openChildCareReport"
      >
        <MiniTooltip text="AI子育てレポート" :offset-x="0" :offset-y="18">
          <v-icon>mdi-baby-carriage</v-icon>
        </MiniTooltip>
      </v-btn>
    </v-speed-dial>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import MiniTooltip from '@/components/MiniTooltip.vue'
import { consumeToken } from '@/js/tokenService'

export default {
  name: 'AiMapChatFab',
  components: { MiniTooltip },
  data() {
    return {
      isOpen: false
    }
  },
  computed: {
    ...mapState([
      'isPrint',
      'isIframe'
    ]),
    showFab() {
      if (this.isPrint || this.isIframe) return false
      return true
    }
  },
  methods: {
    // usageTrackerを取得
    getUsageTracker() {
      const app = this.$root || this.$store.state.oh3App || window.vueApp
      return app?.usageTracker
    },

    // AI物件調査レポート（地図クリック待ち状態で開く）
    async openPropertyReport() {
      // トークン消費はダイアログ内で行う
      this.getUsageTracker()?.trackEvent('ai-fab', 'click', 'ai-propertyReport', { text: 'AI物件調査レポート' })
      this.$store.commit('addFWInstance', {
        type: 'property-report',
        data: { lng: null, lat: null }
      })
    },

    // AI物件調査レポート+ (複数地点比較ランキング)
    async openMultiPointRanking() {
      // トークン消費はダイアログ内で行う
      this.getUsageTracker()?.trackEvent('ai-fab', 'click', 'ai-propertyReport-plus', { text: 'AI物件調査レポート+' })
      const app = this.$root || this.$store.state.oh3App || window.vueApp
      if (app && typeof app.openMultiPointRanking === 'function') {
        app.openMultiPointRanking()
      }
    },

    // AI子育てレポート（地図クリック待ち状態で開く）
    async openChildCareReport() {
      // トークン消費はダイアログ内で行う
      this.getUsageTracker()?.trackEvent('ai-fab', 'click', 'ai-childcareReport', { text: 'AI子育てレポート' })
      this.$store.commit('addFWInstance', {
        type: 'ai-childcare-report',
        data: { lng: null, lat: null }
      })
    },

    // AI人口プロファイル（モード選択ダイアログを開く）
    async openPopulationProfile() {
      // トークン消費はダイアログ内で行う
      this.getUsageTracker()?.trackEvent('ai-fab', 'click', 'ai-populationProfile', { text: 'AI人口プロファイル' })
      const app = this.$root || this.$store.state.oh3App || window.vueApp
      if (app && typeof app.openPopulationProfileModeDialog === 'function') {
        app.openPopulationProfileModeDialog()
      }
    },

    // AI防災診断（モード選択ダイアログを開く）
    async openDisasterAnalysis() {
      // トークン消費はダイアログ内で行う
      this.getUsageTracker()?.trackEvent('ai-fab', 'click', 'ai-disasterAnalysis', { text: 'AI防災診断' })
      const app = this.$root || this.$store.state.oh3App || window.vueApp
      if (app && typeof app.openAreaAnalysisModeDialog === 'function') {
        app.openAreaAnalysisModeDialog()
      }
    },

    // AI地図チャット
    async openMapChat() {
      // トークン消費はダイアログ内で行う
      this.getUsageTracker()?.trackEvent('ai-fab', 'click', 'ai-mapChat', { text: 'AI地図チャット' })
      this.$store.commit('setFloatingVisible', { id: 'map-compare-window', visible: true })
    }
  }
}
</script>

<style scoped>
.ai-fab-container {
  position: fixed;
  bottom: 156px;
  right: 20px;
  z-index: 1002;
}

/* SpeedDialの背景を完全透明に、ぼかし削除 */
.ai-fab-container :deep(.v-speed-dial__content) {
  background: transparent !important;
  box-shadow: none !important;
  border: none !important;
}

/* メニューオーバーレイの影も削除 */
.ai-fab-container :deep(.v-menu > .v-overlay__content) {
  box-shadow: none !important;
  border-radius: 0 !important;
}

.ai-fab {
  width: 64px !important;
  height: 64px !important;
  border-radius: var(--oh3-radius-full) !important;
  background: linear-gradient(135deg, rgb(100, 85, 140), rgb(130, 100, 180)) !important;
  color: white !important;
  box-shadow:
    0 6px 20px rgba(100, 85, 140, 0.45),
    0 3px 10px var(--oh3-color-overlay-20) !important;
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
}

.ai-fab:hover {
  transform: scale(1.1) !important;
  box-shadow:
    0 8px 25px rgba(100, 85, 140, 0.55),
    0 4px 15px rgba(0, 0, 0, 0.25) !important;
}

.ai-fab:active {
  transform: scale(0.95) !important;
}

.rotate-icon {
  transition: transform 0.3s ease;
}

/* SpeedDial アイテム共通 */
.ai-fab-item {
  width: 48px !important;
  height: 48px !important;
  color: white !important;
  transition: transform 0.2s ease !important;
}

.ai-fab-item:hover {
  transform: scale(1.15) !important;
}

/* 各アイテムの色 */
.ai-fab-item.instant {
  background: linear-gradient(135deg, #FF6B6B, #FF8E53) !important; /* オレンジ〜赤 */
}

.ai-fab-item.property-plus {
  background: linear-gradient(135deg, rgb(57, 68, 84), rgb(100, 116, 139)) !important; /* OH3テーマスレート */
}

.ai-fab-item.population {
  background: linear-gradient(135deg, #4CAF50, #8BC34A) !important; /* 緑 */
}

.ai-fab-item.disaster {
  background: linear-gradient(135deg, #2196F3, #03A9F4) !important; /* 青 */
}

.ai-fab-item.childcare {
  background: linear-gradient(135deg, #F8BBD0, #FFCDD2) !important; /* あたたかいピンク */
}

.ai-fab-item:not(.instant):not(.population):not(.disaster):not(.childcare) {
  background: linear-gradient(135deg, rgb(100, 85, 140), rgb(130, 100, 180)) !important; /* 紫 */
}

/* モバイル対応 */
@media (max-width: 500px) {
  .ai-fab-container {
    bottom: 138px;
    right: 16px;
  }

  .ai-fab {
    width: 56px !important;
    height: 56px !important;
  }

  .ai-fab-item {
    width: 44px !important;
    height: 44px !important;
  }
}

/* 印刷時は非表示 */
@media print {
  .ai-fab-container {
    display: none !important;
  }
}
</style>
